var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// Scrolling Text 
$().ready(function(){
  $('.sub-bg').slick({
    arrows: false,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 5.5,
        responsive: [
      {
        breakpoint: 1537,
        settings: {
          slidesToShow: 4.5
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 399,
        settings: {
          slidesToShow: 1.5
        }
      }
    ]
  });
});

// Scrolling Text 2
$().ready(function(){
  $('.abz-sub-bg').slick({
    arrows: false,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 4,
        responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.2
        }
      },
      {
        breakpoint: 399,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  });
});


// Mobile slider 1


$().ready(function(){
  $('.mobile-slider-both-img').slick({
    arrows: true,
    autoplay: false,
    autoplaySpeed: 0,
    dots:false,
    slidesToShow: 5,
        responsive: [
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1,
          prevArrow:'<svg aria-hidden="true" focusable="false" class="icon icon-caret abz-prevarrow" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>',
          nextArrow:'<svg aria-hidden="true" focusable="false" class="icon icon-caret abz-nextarrow" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>'
        }
      }
    ]
  });
});


// Mobile slider 2


$().ready(function(){
  $('.abz-mobile-both-img').slick({
    arrows: true,
    autoplay: false,
    autoplaySpeed: 0,
    dots:false,
    slidesToShow: 4,
        responsive: [
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1,
          prevArrow:'<svg aria-hidden="true" focusable="false" class="icon icon-caret abz-prevarrow" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>',
          nextArrow:'<svg aria-hidden="true" focusable="false" class="icon icon-caret abz-nextarrow" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>'
        }
      }
    ]
  });
});


// $('.abz_product-section').slick({
//     rows:2,
//     slidesToShow: 2,
//     slidesToScroll: 2,
//   responsive: [  
//     {
//       breakpoint: 480,
//       settings: { 
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       infinite: true,
//       autoplay: true,
//       dots: true,
//       rows:1,
//       autoplaySpeed: 4000,
//       }
//     },
//   ]
// });

// // Deatails summary
// $('.facets__disclosure-vertical').removeAttr('open');

// $(".facets__summary").attr("aria-expanded","false");






        